import { GET_ANNOUNCEMENTS, GET_ANNOUNCEMENTS_SUCCESS, GET_ANNOUNCEMENTS_ERROR, GET_ANNOUNCEMENTS_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetAnnouncements = (state = initialState, action) => {
  switch (action.type) {
    case GET_ANNOUNCEMENTS:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_ANNOUNCEMENTS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_ANNOUNCEMENTS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_ANNOUNCEMENTS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetAnnouncements;
